import { useEffect, useState } from "react";
import AllStacksEmptyState from "../AllStacksGrid/EmptyStates/AllStacksEmptyState";
import { useAllStacksPerformanceTracking } from "../AllStacksGrid/useAllStacksPerformanceTracking";
import styles from "./AllStacksList.module.css";
import { AllStacksListItem } from "./AllStacksListItem";

import type { StackFilterOption } from "@mirage/service-settings/service/types";
import { InfiniteScroll } from "@mirage/shared/util/InfiniteScroll/InfiniteScroll";
import type { WorkingSetCardData } from "@mirage/working-set";

const STACKS_SHOWN = 10;

export const AllStacksList = ({
  workingSetCardData,
  suggestedCardData,
  filterPreference,
}: {
  workingSetCardData: WorkingSetCardData[];
  suggestedCardData: WorkingSetCardData[];
  filterPreference?: StackFilterOption;
}) => {
  const [currentOffset, setCurrentOffset] = useState(0);
  useAllStacksPerformanceTracking();

  useEffect(() => {
    setCurrentOffset(0);
  }, [filterPreference]);

  return (
    <div className={styles.allStacksList}>
      {suggestedCardData.map((suggestedData) => (
        <AllStacksListItem
          key={suggestedData.id}
          workingSetCardData={suggestedData}
        />
      ))}

      {!workingSetCardData.length && (
        <AllStacksEmptyState filterPreference={filterPreference} />
      )}

      {workingSetCardData
        .slice(0, currentOffset + STACKS_SHOWN)
        .map((workingSetData) => (
          <AllStacksListItem
            key={workingSetData.id}
            workingSetCardData={workingSetData}
          />
        ))}

      {currentOffset < workingSetCardData.length && (
        <InfiniteScroll
          onTrigger={() => setCurrentOffset(currentOffset + STACKS_SHOWN)}
          key={currentOffset}
        />
      )}
    </div>
  );
};
